import React from 'react'
import { Link } from 'react-router-dom'
import './hero-section.scss'

const HeroSection = () => {
    return (
        <>
            <div className="container">
                <div className="hero-section-bg">
                    <div className="hero-content">
                        <h2>Trusted by Global Brands, <span>Built for Travelers</span></h2>
                        <p>Discover the companies we work with to enhance your travel experience.</p>
                        <Link to="">Become a Partner</Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeroSection